export default {"src":"/_next/static/media/protein.6f2ead17.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};